import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import ReverseService from "../../../services/ReverseService";
import CollectOrderService from "../../../services/CollectOrderService";
import TiposColeta from "../../../enums/TiposColeta";
import SgsService from "../../../services/SgsService";
import MinorCollectOrderDetails from "../../molecules/MinorCollectOrderDetails";
import CamposColetor, { coletorDoForm } from "../../molecules/CamposColetor";

export default function SendToExpeditionModal({
  isModalOpen,
  setModalOpen,
  collectOrderId,
  requestNro,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    watch,
  } = useForm({ defaultValues: { notificarPortaria: false } });

  const [collectOrderObject, setCollectOrderObject] = useState();

  useEffect(() => {
    async function fetchRequest() {
      const cOrder = await CollectOrderService.getCollectOrdersById(
        collectOrderId
      );
      setCollectOrderObject(cOrder);
    }

    fetchRequest();
  }, [isModalOpen]);

  const [enviando, setEnviando] = useState(false);

  // Notificar é opcional: o coletor pode não ser conhecido na hora, e a
  // expedição não pode parar por causa disso. Quem ficou sem alerta aparece na
  // lista de ROTA DE COLETA com o botão "Notificar Coleta".
  const notificar = watch("notificarPortaria");

  const onSubmit = async (form) => {

    const data = { status: "ROTA DE COLETA" };

    // Só manda coletor quando for notificar — campo vazio no backend significa
    // "expedir sem alerta", e um objeto meio preenchido seria recusado.
    if (notificar) {
      data.coletor = coletorDoForm(form);
    }

    setEnviando(true);
    try {
      await CollectOrderService.updateParcial(collectOrderId, data);
      toast.success(notificar
        ? "Enviada para expedição! A portaria foi notificada."
        : "Enviada para expedição (sem notificar a portaria).");
      setModalOpen(!isModalOpen);
      reset();
    } catch (error) {
      // Mantém o modal aberto para o usuário corrigir sem redigitar tudo.
      toast.error(error.message);
    } finally {
      setEnviando(false);
    }

  };

  // Quando não é para notificar, nem passa pelo handleSubmit: os campos do
  // coletor saem da tela mas continuam registrados no form, e deixar a
  // validação deles decidir faria o botão "Enviar" não responder.
  const onClickEnviar = () => (notificar ? handleSubmit(onSubmit)() : onSubmit({}));

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[648px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-6" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 text-left gap-2 bg-gray-800 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4">
                  ENVIAR PARA ROTA DE COLETA
                </div>
                <div className="flex justify-between">
                  <div className="text-white text-sm px-4">
                    Coleta:{" "}
                    {collectOrderObject?.collectOrder.idCollectOrder}
                  </div>
                  <div className="text-white text-sm px-4">
                    Ref Solicitação:{" "}
                    {collectOrderObject?.collectOrder.idRequest}
                  </div>
                </div>
              </div>

              <MinorCollectOrderDetails collectOrder={collectOrderObject?.collectOrder} />

              {/* MODAL FORM BEGIN */}
              <div className="flex flex-col mt-6 px-6">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-sm gap-4">

                    <label className="flex items-start gap-2 cursor-pointer bg-gray-100 rounded-md px-3 py-2">
                      <input
                        type="checkbox"
                        {...register("notificarPortaria")}
                        className="mt-[3px] h-4 w-4 cursor-pointer"
                      />
                      <span>
                        <span className="font-bold text-gray-700">
                          Informar Coletor e notificar portaria?
                        </span>
                        <span className="block text-[11px] text-gray-600">
                          {notificar
                            ? "A portaria vai receber um e-mail com estes dados e a Guia de Expedição anexada."
                            : "Sem marcar, a coleta segue para rota normalmente e nenhum alerta é enviado. Dá para notificar depois, pelo botão \"Notificar Coleta\" na lista de ROTA DE COLETA."}
                        </span>
                      </span>
                    </label>

                    {notificar && (
                      <CamposColetor register={register} errors={errors} />
                    )}

                    <div className="flex gap-4">
                      <button
                        disabled={enviando}
                        onClick={onClickEnviar}
                        className="w-full bg-blue-400 text-white py-2 px-4 rounded-md hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed"
                      >
                        {enviando ? "Enviando..." : "Enviar para Rota de Coleta"}
                      </button>

                      <button
                        onClick={() => setModalOpen(!isModalOpen)}
                        className="w-full bg-neutral-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}
